import { animate, style, transition, trigger } from '@angular/animations';

export const reportInOutAnimation = trigger('reportInOutAnimation', [
	transition(':enter', [
		style({ height: '0' }),
		animate('200ms ease-in', style({ height: '64px', transform: 'translateY(0)' })),
	]),
	transition(':leave', [
		style({ height: '64px' }),
		animate('200ms ease-in', style({ height: '0', transform: 'translateY(-64px)' })),
	]),
]);

export const fadeAnimation = trigger('fadeAnimation', [
	transition(':enter', [
		style({
			opacity: '0',
		}),
		animate(
			'50ms ease-in',
			style({
				opacity: '1',
			}),
		),
	]),
	transition(':leave', [
		style({
			opacity: '1',
		}),
		animate('350ms ease-in', style({ opacity: '0' })),
	]),
]);

export const fadeAnimation_times = (inTime = 200, outTime = 350) =>
	trigger('fadeAnimation', [
		transition(':enter', [
			style({
				opacity: '0',
			}),
			animate(
				`${inTime}ms ease-in`,
				style({
					opacity: '1',
				}),
			),
		]),
		transition(':leave', [
			style({
				opacity: '1',
			}),
			animate(`${outTime}ms ease-in`, style({ opacity: '0' })),
		]),
	]);
